import {combineReducers} from "@reduxjs/toolkit";
import send from "features/modals/send-message/reducer";

export default combineReducers({
    send
});